import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciAccordionPanelComponent } from './luci-accordion-panel.component';



@NgModule({
  declarations: [LuciAccordionPanelComponent],
  exports: [LuciAccordionPanelComponent],
  imports: [
    CommonModule
  ]
})
export class LuciAccordionPanelModule { }
